<template>
  <div class="table-section">
    <v-container grid-list-xs class="my-5">
      <div>
        <v-row>
          <v-col cols="4" sm="4" md="4" lg="4">
            <v-switch
              label="Buka Gelombang"
              v-model="gelombang"
              @change="changeGelombang"
            ></v-switch>
          </v-col>
          <v-col cols="4" sm="4" md="4" lg="4"></v-col>
          <v-col
            cols="4"
            sm="4"
            md="4"
            lg="4"
            class="d-flex justify-space-around align-center"
          >
            <ImportExcelBtn />
            <v-btn color="error" @click="logout">Logout</v-btn>
          </v-col>
        </v-row>
      </div>

      <v-card flat class="pa-5">
        <v-row>
          <v-col cols="4" sm="4" md="4" lg="4"></v-col>
          <v-col cols="4" sm="4" md="4" lg="4"></v-col>
          <v-col cols="4" sm="4" md="4" lg="4">
            <v-text-field
              v-model="search"
              label="Search..."
              single-line
              hide-details
              class="mb-2"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="students"
          :items-per-page="15"
          :search="search"
        >
          <template v-slot:[`item.sw_nama_lengkap`]="{ item }">
            <router-link :to="`/siswa/${item.sw_id}`">{{
              item.sw_nama_lengkap
            }}</router-link>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>


<script>
// jj
import axios from "axios";
import { EventBus } from "../event-bus";
import moment from "moment";

import ImportExcelBtn from "../components/ImportExcel";

export default {
  components: {
    ImportExcelBtn,
  },
  data: () => ({
    students: [],
    search: "",
    role: "",
    gelombang: "",
    headers: [
      { text: "#", value: "id" },
      { text: "No Pendaftaran", value: "sw_id" },
      { text: "Nama Siswa", value: "sw_nama_lengkap" },
      { text: "Tanggal", value: "sw_updated_at" },
      { text: "Jurusan", value: "sw_jurusan" },
      { text: "Status", value: "sw_status" },
    ],
  }),
  mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          localStorage.clear();
          let hostDestination =
            window.location.hostname === "localhost"
              ? `localhost:${window.location.port}`
              : window.location.hostname;

          window.location.href = `http://${hostDestination}`;
        }
        return Promise.reject(error);
      }
    );
    this.role = localStorage.getItem("role");
    EventBus.$emit("startLoading");
    this.getStudents();
    this.getGelombang();
  },
  methods: {
    async getStudents() {
      EventBus.$emit("startLoading");
      const res = await axios.get(
        `${this.$api}/admin/siswa?qwertyuiop=qwertyuiop`
      );
      if (res.data.STATUS === "SUCCESS") {
        let students = res.data.PAYLOAD;
        students.sort((a, b) => (a.sw_updated_at > b.sw_updated_at ? -1 : 1));

        let newStudents = students.filter((student) => {
          if (this.role == 2) return student.sw_status <= 3;
          else if (this.role == 3)
            return student.sw_status >= 4 && student.sw_status <= 7;
          else if (this.role == 4) return student.sw_status >= 7;
        });

        let count = 1;
        newStudents.forEach((student, index) => {
          let updatedAt = moment(String(student.sw_updated_at)).format(
            "DD-MM-YYYY"
          );
          let status = this.studentStatus(student.sw_status);

          newStudents[index] = {
            ...student,
            id: count,
            sw_updated_at: updatedAt,
            sw_status: status,
          };

          count++;
        });

        this.students = newStudents;
        EventBus.$emit("stopLoading");
      }
    },

    async changeStudentStatus(id, status) {
      await axios.post(`${this.$api}/admin/konfirmasi-tes`, {
        sw_id: id,
        token: "chAdiG-2019",
        type: status,
      });

      const index = this.students.findIndex((student) => student.sw_id === id);
      const statusStudent = status === "ACCEPT" ? "Diterima" : "Belum Diterima";
      const newStudentStatus = {
        ...this.students[index],
        sw_status: statusStudent,
      };
      this.students.splice(index, 1, newStudentStatus);
    },

    studentStatus(status) {
      if (this.role == 2) {
        if (status == 0 || status == 2) return "Belum Terverifikasi";
        else if (status == 1) return "Pending";
        else if (status >= 3) return "Terverifikasi";
      } else if (this.role == 3) {
        if (status == 4 || status == 6) return "Belum Terverifikasi";
        else if (status == 5) return "Pending";
        else if (status >= 7) return "Terverifikasi";
      } else if (this.role == 4) {
        if (status == 7) return "Pending";
        else if (status == 8) return "Tidak Diterima";
        else if (status == 9) return "Diterima";
      }
    },

    async getGelombang() {
      EventBus.$emit("startLoading");
      const res = await axios.get(`${this.$api}/admin/cek-gelombang`);

      if (res.data.STATUS === "SUCCESS")
        this.gelombang = res.data.PAYLOAD.is_open === "Y" ? true : false;
      EventBus.$emit("stopLoading");
    },

    async changeGelombang() {
      const gelombangStatus = this.gelombang ? "Y" : "N";

      await axios.post(`${this.$api}/admin/switch`, {
        status: gelombangStatus,
        token: "chAdiG-2019",
      });
    },

    logout() {
      EventBus.$emit("startLoading");

      localStorage.removeItem("id");
      localStorage.removeItem("username");
      localStorage.removeItem("token");

      EventBus.$emit("stopLoading");

      this.$router.push({ name: "login" });
    },
  },
};
</script>